<script>
import axios from "axios";
import VueSimpleSpinner from 'vue-simple-spinner';

export default {
  props: {
    initialClub: {
      default: '',
      type: String
    },
    redirect: {
      type: String,
      default: '/wine-club/confirmation'
    }
  },

  data() {
    return {
      shippingInfoSame: true,
      loading: false,
      isGift: false,
      clubSelect: this.initialClub,
      clubAddon: null,
      formErrors: false,
      success: false,
      paymentUpdate: false,
      submitted: false
    }
  },

  components: {
    VueSimpleSpinner
  },

  methods: {
    submitForm(event) {
      this.loading = true;
      this.submitted = true;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.sendFormData(event.target);
          return;
        }

        // there was an error
        this.loading = false;
        this.submitted = false;
      });
    },

    sendFormData(form) {
      // use URLSearchParams to format data as application/x-www-form-urlencoded for Craft2
      let params = new URLSearchParams();
      const formData = new FormData(form);
      for (const pair of formData.entries()) {
        params.append(
          pair[0],
          pair[1]
        );
      }

      axios({
        method: 'post',
        url: '/',
        data: params,
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then((response) => {
        this.loading = false;
        // console.log(response.data);
        if (response.data.errors) {
          this.success = false
          this.submitted = false
          this.formErrors = response.data.errors
          window.scrollTo(0,0);
        }

        if (response.data.success) {
          this.formErrors = false
          this.success = true
          window.location = this.redirect
        }
      })
      .catch((error) => {
        this.loading = false;
        this.submitted = false;
        this.formErrors = 'There was an unknown error submitting the form, please try again.'
        // console.log('Club Signup Error:', error);
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/ClubSignup.vue